import { t } from '../../lib/i18n';
import { useCan } from '../../lib/session';
import { PageHeader } from '../../components/ui';
import { SettingsEditor } from '../../components/SettingsEditor';
import { Card } from '../../components/ui';
import { Tabs, useTab } from '../sites/Tabs';
import { DevicesTab } from './DevicesTab';
import { KioskEventsTab } from './KioskEventsTab';
import { PrintersTab } from './PrintersTab';

/** The module's tenant-wide settings (alert thresholds and how much history to keep). */
function AlertSettingsTab() {
  const canEdit = useCan('sites.manage_devices');
  return (
    <Card title={t('devicesUi.alertSettings.title')} description={t('devicesUi.alertSettings.description')}>
      <SettingsEditor moduleKey="kiosk-devices" base="/settings" canEdit={canEdit} />
    </Card>
  );
}

export function DevicesPage() {
  const canReview = useCan('history.view');
  const tabs = [
    { key: 'devices', label: t('devicesUi.tab.devices') },
    { key: 'printers', label: t('devicesUi.tab.printers') },
    ...(canReview ? [{ key: 'events', label: t('w23.kioskEvents.tab') }] : []),
    { key: 'alerts', label: t('devicesUi.tab.alerts') },
  ];
  const [tab, setTab] = useTab(tabs);
  return (
    <>
      <PageHeader title={t('devicesUi.title')} description={t('devicesUi.description')} />
      <Tabs tabs={tabs} current={tab} onChange={setTab} label={t('devicesUi.tabs')}>
        {tab === 'printers' ? <PrintersTab /> : tab === 'alerts' ? <AlertSettingsTab /> : tab === 'events' ? <KioskEventsTab /> : <DevicesTab />}
      </Tabs>
    </>
  );
}
